import React from 'react'
import {Box} from '@chakra-ui/react'
import Header from './Header.jsx'
import Planes from './Planes.jsx'
import Footer from './Footer.jsx'
import SEO from './SEO.jsx'

const PlanesPage = () => (
  <Box>
    <SEO
      title="Planes"
      description="Planes de Cadencya para bandas: Gratis, Estándar, Intermedio y Avanzado. Las hermandades usan un plan gratuito."
      path="/planes"
    />
    <Header />
    <Planes />
    <Footer />
  </Box>
)

export default PlanesPage
